<div class="max-w-500px h-auto">
    <div class="text-lg font-denim-semibold" mat-dialog-title>
        Lease Renewed
    </div>
    <mat-dialog-content>
        <div class="flex flex-col text-base font-denim-semibold">
            <div class="flex flex-wrap">
                Thank you for choosing to renew your lease with us.
            </div>
            <div class="flex flex-wrap">
                If you selected the Premier or Preferred Plan, your renewal lease will be emailed to {{emailAddress}} within the next 48 hours.
                It must be signed 48 hours from receipt to avoid an automatic cancellation. Please ensure all residents over the age of 18 sign the lease.
            </div>
            <div class="flex flex-wrap">
                Thank you for choosing to renew your lease with us.
            </div>
        </div>
        <div class="w-full">
            <button mat-flat-button color="primary" class="w-full my-2 font-denim-semibold" [mat-dialog-close]="true"  (click)="logOut()">FINISHED</button>
        </div>
    </mat-dialog-content>
</div>
